export default __webpack_public_path__ + "static/media/Bild1.1fe482a1.png";